import React from 'react';
import isInt from 'validator/lib/isInt';
import {
  Button,
  Confirm,
  Form,
  FormField,
  Grid,
  Segment,
} from 'semantic-ui-react';
import { Field, Form as FinalForm } from 'react-final-form';
import ValidatedTextArea from 'components/ValidatedTextArea';
import { requiredStringValidation } from 'utils/formUtils';
import ValidatedDatePicker from 'components/ValidatedDatePicker';
import PropTypes from 'prop-types';
import LogModal from 'pages/BulkOutletUpdateExpiration/LogModal';
import { confirmProcess } from 'state/bulkOutletUpdateExpiration/actions';
import { useDispatch, useSelector } from 'react-redux';

function parseOutletIds(outletIds) {
  if (!outletIds) {
    return '';
  }
  return outletIds.replace(/[^\d\n]/g, '');
}

function countIdsAll(ids) {
  return (ids || '').split('\n').filter(i => isInt(i, { min: 0 })).length;
}

function countDistinct(ids) {
  const rawArray = (ids || '').split('\n');
  return [...new Set(rawArray)].filter(i => isInt(i, { min: 0 })).length;
}

const requiredExpiredDateValidation = value =>
  !value ? 'New Expiration Date is required' : undefined;

const renderForm = ({ handleSubmit, values }) => {
  const countAll = countIdsAll(values.outlet_ids);
  const duplicateCount = countAll - countDistinct(values.outlet_ids);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid columns="equal">
        <Grid.Column width={8}>
          <FormField>
            <label htmlFor="outlet-ids">
              Insert outlet IDs here separated with line breaks
            </label>
            <Field
              id="outlet-ids"
              name="outlet_ids"
              component={ValidatedTextArea}
              parse={parseOutletIds}
              validate={requiredStringValidation()}
              style={{ minHeight: '500px' }}
            />
          </FormField>
        </Grid.Column>
        <Grid.Column>
          <div>
            Count: {countAll}{' '}
            {duplicateCount > 0 ? `(${duplicateCount} duplicates)` : ''}
          </div>
          <br />
          <FormField>
            <label htmlFor="expired-at">New Expiration Date:</label>
            <Field
              id="expired-at"
              name="expired_at"
              component={ValidatedDatePicker}
              validate={requiredExpiredDateValidation}
            />
          </FormField>
          <Button primary type="submit">
            Submit
          </Button>
        </Grid.Column>
      </Grid>
    </Form>
  );
};

renderForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};

function MainPage({ onSubmit, onShowLogButtonClicked }) {
  const dispatch = useDispatch();
  const confirmModalShown = useSelector(
    state => state.bulkOutletUpdateExpiration.confirmModalShown
  );

  return (
    <>
      <LogModal />
      <Confirm
        open={confirmModalShown}
        confirmButton={{ negative: true, content: 'Confirm' }}
        onCancel={() => dispatch(confirmProcess(false))}
        onConfirm={() => dispatch(confirmProcess(true))}
        header="Confirm Bulk Update Outlet Expiration"
        content="Are you sure to perform this operation? Any progress cannot be rolled back"
      />
      <Button basic color="black" onClick={onShowLogButtonClicked}>
        Show Logs
      </Button>
      <Segment>
        <h3>Outlet IDs</h3>
        <FinalForm render={renderForm} onSubmit={onSubmit} />
      </Segment>
    </>
  );
}

MainPage.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onShowLogButtonClicked: PropTypes.func.isRequired,
};

export default MainPage;
